import React from 'react';

import { FormField } from '@gogame/form';

import { loadAffiliates } from 'scenes/IO/sources/io';

import { AFFILIATES, DEPENDENCIES } from '../constants';

const AffiliatesField = ({ label, validate, disabled, required }) => {
  return (
    <FormField.MultiSelect
      name={AFFILIATES}
      depends={DEPENDENCIES[AFFILIATES]}
      source={loadAffiliates}
      validate={validate}
      disabled={disabled}
      padding={0}
      label={label}
      required={required}
    />
  );
};

export default AffiliatesField;
